import NavButton from 'components/ui/Button/NavButton';
import { useNavigate } from 'react-router';
import Voteimage from 'assets/img/votes.png';

const SuccessEvaluation = () => {
    const navigate = useNavigate();

    return (
      <>
        <div className="flex flex-col items-center justify-between mx-4 gap-9 md:flex-row md:mx-0">
          <div className="flex-1">
            <h2 className="mb-3 text-[32px] font-bold text-black-bb font-title">
              Seus votos foram enviados!
            </h2>
            <div className="flex flex-col gap-5 mt-16 mb-5 content">
              <p>
                50% das iniciativas da sua Unidade Estratégica, mais bem
                pontuadas na 1ª etapa de avaliação, com arredondamento para
                cima, farão parte da 2ª etapa de avaliação.
              </p>
              <p>
                E todas essas iniciativas receberão o Prêmio Coletivo em Espécie
                de 50 mil. Legal, né? Fique ligado,<b> até o dia 28 de março</b>
                divulgaremos as iniciativas premiadas com o Prêmio Coletivo.
              </p>
              
              <p>
                De <b>20 de março a 3 de abril</b>, realizaremos a 2ª etapa de
                avaliação. Nesta etapa, os(as) Vice-Presidentes(as) ou a
                Presidenta (para as Diretorias vinculadas à presidência) irão
                escolher as iniciativas de suas áreas subordinadas que mais
                representem as categorias do Prêmio BB.
              </p>
            </div>

            <NavButton
              text="Mostrar meus votos"
              bgColor="#FCFC30"
              onClick={() => navigate("/evaluation")}
            />
          </div>
          <div className="flex-1">
            <img
              width={"100%"}
              src={Voteimage}
              alt=""
              className="relative top-8"
            />
          </div>
        </div>
      </>
    );
};

export default SuccessEvaluation;
